import React from 'react';
import styled from 'styled-components';

import { hideScrollbars } from 'styles/utils/hideScrollbars';
import { PRODUCT_ROWS_PER_PAGE } from 'homepage/enums/contentConstants';
import { splitCuratedLinksIntoList } from 'homepage/utils/splitCuratedLinksIntoList';
import { ProductListTable } from 'homepage/components/detailedProductListSection/ProductListTable';
import { useTriggerSwipeEvent } from 'homepage/hooks/useTriggerSwipeEvent';

import { IModuleTrackingData } from 'homepage/types/ModuleTrackingData';
import { IConstructorResult } from 'shared/types/ConstructorResult';

interface IProductListTableCarousel {
  moduleTrackingData: IModuleTrackingData;
  results?: IConstructorResult[];
}

/**
 * [ProductListTableCarousel]
 * Splits results into "pages" of 4 products, and renders them in a carousel.
 * @param  results     {Array} results The products to show.
 */

export const ProductListTableCarousel = ({
  moduleTrackingData,
  results = [],
}: IProductListTableCarousel) => {
  const productDetailsSets = splitCuratedLinksIntoList(results, PRODUCT_ROWS_PER_PAGE);
  const { trackScrollEvent } = useTriggerSwipeEvent(moduleTrackingData);

  return (
    <ProductListTableCarousel.Container onScroll={trackScrollEvent}>
      {productDetailsSets.map((page, index) => {
        return (
          <ProductListTableCarousel.Card
            key={`${page.curatedLinkIdHash}`}
            products={page.items}
            pageOffset={index * PRODUCT_ROWS_PER_PAGE}
            moduleTrackingData={moduleTrackingData}
          />
        );
      })}
    </ProductListTableCarousel.Container>
  );
};

ProductListTableCarousel.Container = styled.div`
  display: flex;
  width: 100%;
  overflow-x: scroll;
  ${hideScrollbars}
`;

ProductListTableCarousel.Card = styled(ProductListTable)`
  flex: 0 0 100%;

  -webkit-scroll-snap-align: start;
  scroll-snap-align: start;
`;
